import { useQuery } from '@tanstack/react-query';
import api from '../../api';

function slugify(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

const FALLBACK_INTERNAL = [
  { group: 'internalSystems', title: 'PSA', code: 'psa', icon: '📊', sortOrder: 10, defaultStatus: 'Not Started', isRequired: false, isActive: true },
  { group: 'internalSystems', title: 'AEM', code: 'aem', icon: '🖥️', sortOrder: 20, defaultStatus: 'Not Started', isRequired: false, isActive: true },
  { group: 'internalSystems', title: 'Fincon', code: 'fincon', icon: '💰', sortOrder: 30, defaultStatus: 'Not Started', isRequired: false, isActive: true },
  { group: 'internalSystems', title: 'IT Glue', code: 'it-glue', icon: '📋', sortOrder: 40, defaultStatus: 'Not Started', isRequired: false, isActive: true },
];

const FALLBACK_COMPANY = [
  { group: 'companyWide', title: 'Email Migration', code: 'email-migration', icon: '📧', sortOrder: 10, defaultStatus: 'Not Started', isRequired: false, isActive: true },
  { group: 'companyWide', title: 'Domain DNS', code: 'domain-dns', icon: '🌐', sortOrder: 20, defaultStatus: 'Not Started', isRequired: false, isActive: true },
  { group: 'companyWide', title: 'Website Migration', code: 'website-migration', icon: '🌍', sortOrder: 30, defaultStatus: 'Not Started', isRequired: false, isActive: true },
  { group: 'companyWide', title: 'Include Backups', code: 'include-backups', icon: '💾', sortOrder: 40, defaultStatus: 'Not Started', isRequired: false, isActive: true },
  { group: 'companyWide', title: 'Acronis Advanced Email Security', code: 'acronis-advanced-email-security', icon: '🛡️', sortOrder: 50, defaultStatus: 'Not Started', isRequired: false, isActive: true },
];

const FALLBACK_BRANCH = [
  { group: 'branchServices', title: 'Install MiBOT Agent', code: 'install-mibot-agent', icon: '🤖', sortOrder: 10, defaultStatus: 'Not Started', isRequired: false, isActive: true },
  { group: 'branchServices', title: 'Install Managed AV', code: 'install-managed-av', icon: '🛡️', sortOrder: 20, defaultStatus: 'Not Started', isRequired: false, isActive: true },
  { group: 'branchServices', title: 'Setup Office 365 / Mail', code: 'setup-office-365-mail', icon: '📨', sortOrder: 30, defaultStatus: 'Not Started', isRequired: false, isActive: true },
  { group: 'branchServices', title: 'Setup OneDrive', code: 'setup-onedrive', icon: '☁️', sortOrder: 40, defaultStatus: 'Not Started', isRequired: false, isActive: true },
  { group: 'branchServices', title: 'Install CyberFox', code: 'install-cyberfox', icon: '🔐', sortOrder: 50, defaultStatus: 'Not Started', isRequired: false, isActive: true },
  { group: 'branchServices', title: 'Install Acronis Backup Agent', code: 'install-acronis-backup-agent', icon: '💿', sortOrder: 60, defaultStatus: 'Not Started', isRequired: false, isActive: true },
];

export function getFallbackTemplates() {
  return [...FALLBACK_INTERNAL, ...FALLBACK_COMPANY, ...FALLBACK_BRANCH].map((t) => ({
    ...t,
    code: t.code || slugify(t.title),
    fieldsSchema: null,
  }));
}

export function useCompanyTaskTemplates(companyId, options = {}) {
  return useQuery({
    queryKey: ['taskTemplates', 'company', companyId],
    queryFn: async () => {
      const res = await api.get('/task-templates', { params: { companyId } });
      return Array.isArray(res.data) ? res.data : [];
    },
    enabled: !!companyId,
    ...options,
  });
}

export function useTaskTemplates(sectorId, options = {}) {
  return useQuery({
    queryKey: ['taskTemplates', 'sector', sectorId],
    queryFn: async () => {
      const res = await api.get('/task-templates', { params: { sectorId, _t: Date.now() } }); // Cache-busting
      return Array.isArray(res.data) ? res.data : getFallbackTemplates();
    },
    initialData: getFallbackTemplates(),
    staleTime: 0, // Always refetch on mount to get latest templates
    ...options,
  });
}


